import React from "react";
import { StaffTrainingProvider } from './context/StaffTrainingContext';
import TrainingDetailsDialog from './components/TrainingDetailsDialog';
import { useStaffTraining } from './context/StaffTrainingContext';

import DefaultLayout from "../../layouts/default";

import StaffTrainingDashboard from "./components/StaffTrainingDashboard";
import TrainingActionPanels from "./components/TrainingActionPanels";
import TrainingComplianceTable from "./components/TrainingComplianceTable";
import TrainingDashboardBottom from "./components/TrainingDashboardBottom";

 function DashboardContent() {
  const { error, refresh } = useStaffTraining();
  return (
    <DefaultLayout>
      <div className="min-h-screen bg-slate-50/50 flex flex-col gap-6">
        {error && <div role="alert" className="rounded-lg bg-red-50 p-4 text-sm text-red-700">{error} <button onClick={refresh} className="font-semibold underline">Retry</button></div>}

        {/* Row 1: Dashboard Header + Statistics */}
        <StaffTrainingDashboard />

        {/* Row 2: Compliance Table + Action Panels */}
        <div className="flex flex-col lg:flex-row gap-6 items-start">
          <div className="w-full lg:flex-1 min-w-0">
            <TrainingComplianceTable />
          </div>

          <div className="w-full lg:w-[360px] shrink-0">
            <TrainingActionPanels />
          </div>
        </div>

        {/* Row 3: Bottom Dashboard */}
        <TrainingDashboardBottom />
        <TrainingDetailsDialog />

      </div>
    </DefaultLayout>
  );
}

export default function StaffTrainingPage() { return <StaffTrainingProvider><DashboardContent /></StaffTrainingProvider>; }
